<!DOCTYPE html>
<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<ng-container *ngIf="user">
  <app-toolbar  [title]="title"  [user]="user" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>

<div class="column">
    <h2>Pazienti globali - Utenti inattivi per malattia iniziale attiva/inattiva (analisi HBI/SCCAI)</h2>
    <h3>L'analisi è stata effettuata considerando i pazienti che hanno compilato il questionario HBI/SCCAI.</h3>
    <h3>Cut-off: 5.</h3>
    <div style="display: inline-block" style="padding-left: 2vw; padding-top: 1vw">
      <div class = "chart-container" >
        <canvas id = "myChartInactiveMalattiaIniziale"></canvas>
      </div>
    </div>
  </div>
  <app-bar-chart-inactive-malattia-iniziale-miah></app-bar-chart-inactive-malattia-iniziale-miah>